import { PeriodProvider } from "@/providers/Period";
import { GlobeIcon } from "@phosphor-icons/react";
import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { EditTransportadora } from "./Transportadoras/children/edit";

const CargaPage = lazy(() => import("./Carga"));
const AdicionarCargaEntrada = lazy(() => import("./Carga/AdicionarCargaEntrada"));
const ListCarregamento = lazy(() => import("./Carregamento/create"));
const ExpedicaoClientes = lazy(() => import("./Clientes"));
const DetalhesClientes = lazy(() => import("./Clientes/Components/Details").then((m) => ({ default: m.DetalhesClientes })));
const Container = lazy(() => import("./ContainerPage"));
const FilialFakeErpComponent = lazy(() => import("./Filial"));
const EntradaFornecedor = lazy(() => import("./Fornecedores"));
const NotaItensERPComponentV2 = lazy(() => import("./NotaItens"));
const FormItemNota = lazy(() => import("./NotaItens/FormItemNota").then((m) => ({ default: m.FormItemNota })));
const ImportNotaItem = lazy(() => import("./NotaItens/ImportNotaItem"));
const NotaERPComponent = lazy(() => import("./Notas"));
const ModalCadastroDeNotas = lazy(() => import("./Notas/Components/ModalCadastroDeNotas").then((m) => ({ default: m.ModalCadastroDeNotas })));
const PedidoErp = lazy(() => import("./Pedido").then((m) => ({ default: m.PedidoErp })));
const FormAddItemPedido = lazy(() => import("./Pedido/itensPedido/FormAddItemPedido").then((m) => ({ default: m.FormAddItemPedido })));
const CriarProdutoErp = lazy(() => import("./Products/CriarProduto/CriarProdutoErp").then((m) => ({ default: m.CriarProdutoErp })));
const ListProdutoERP = lazy(() => import("./Products/ListProdutoERP").then((m) => ({ default: m.ListProdutoERP })));
const ExpedicaoRegioes = lazy(() => import("./Regioes"));
const ExpedicaoRotas = lazy(() => import("./Rotas"));
const ExpedicaoTransportadoras = lazy(() => import("./Transportadoras"));
const DetalhesTransportadoras = lazy(() => import("./Transportadoras/Components/Details").then((m) => ({ default: m.DetalhesTransportadoras })));
const ExpedicaoVeiculoTransportadoras = lazy(() => import("./VeiculosDeTransportadoras"));
const DetalhesVeiculoTransportadoras = lazy(() => import("./VeiculosDeTransportadoras/Components/Details").then((m) => ({ default: m.DetalhesVeiculoTransportadoras })));
const GrupoErpComponent = lazy(() => import("./grupo"));
const SubGrupoErp = lazy(() => import("./subGrupo").then((m) => ({ default: m.SubGrupoErp })));
const CidadeErp = lazy(() => import("./Cidade").then((m) => ({ default: m.CidadeErp })));


export const ModuleFakeErp = {
  menuItem: {
    to: "/fakerp",
    title: "ERP",
    id: 12,
    icon: GlobeIcon,
    childrens: [
      {
        to: "/fakerp/filial-erp",
        title: "Filial",
        fullTitle: "Cadastro de Filial",
        id: 47
      },
      {
        to: "/fakerp/consulta-de-fornecedores",
        title: "Fornecedores",
        fullTitle: "Consulta de Fornecedores",
        id: 53,
      },
      {
        to: "/fakerp/cadastro-de-grupo",
        title: "Grupo",
        fullTitle: "Cadastro de Grupo",
        id: 54
      },
      {
        to: "/fakerp/cadastro-de-subgrupo",
        title: "SubGrupo",
        fullTitle: "Cadastro de SubGrupo",
        id: 55
      },
      {
        to: "/fakerp/produtos",
        title: "Produtos",
        fullTitle: "Cadastro de Produtos",
        id: 56
      },
      {
        hasDivider: true,
        to: "/fakerp/consulta-de-regioes",
        title: "Regiões",
        fullTitle: "Consulta de Regiões",
        id: 57
      },
      {
        to: "/fakerp/consulta-de-rotas",
        title: "Rotas",
        fullTitle: "Consulta de Rotas",
        id: 60
      },
      {
        to: "/fakerp/consulta-de-clientes",
        title: "Clientes",
        fullTitle: "Consulta de Clientes",
        id: 61,
      },
      {
        to: "/fakerp/consulta-de-cidades",
        title: "Cidades",
        fullTitle: "Consulta de Cidades",
        id: 61, //@todo pegar o id do modulo de criacao de cidades
      },
      {
        to: "/fakerp/consulta-de-transportadoras",
        title: "Transportadoras",
        fullTitle: "Consulta de Transportadoras",
        id: 62,
      },
      {
        to: "/fakerp/consulta-de-veiculos-de-transportadoras",
        title: "Veículos",
        fullTitle: "Consulta de Veículo Transportadora",
        id: 63,
      },
      {
        hasDivider: true,
        to: "/fakerp/carga",
        title: "Cargas",
        fullTitle: "Listagem de Carga",
        id: 64
      },
      {
        to: "/fakerp/cadastro-de-carga",
        title: "Carga Entrada",
        fullTitle: "Cadastro de Carga",
        id: 65
      },
      {
        to: "/fakerp/cadastro-de-nota",
        title: "Nota",
        fullTitle: "Cadastro de Nota",
        id: 66
      },
      {
        hasDivider: true,
        to: "/fakerp/cadastro-de-carregamento",
        title: "Carga Saida",
        fullTitle: "Cadastro de Carregamento",
        id: 67,
      },
      {
        to: "/fakerp/pedido",
        title: "Pedidos",
        fullTitle: "Cadastro de Pedidos",
        id: 68
      },
      {
        hasDivider: true,
        to: "/fakerp/importacao-container",
        title: "Container",
        fullTitle: "Importar Container",
        id: 69,
      },
    ],
  },

  routes: [
    {
      path: "/fakerp/cadastro-de-carga",
      element: <AdicionarCargaEntrada />,
    },
    {
      path: "/fakerp/carga",
      element: <CargaPage />,
    },
    {
      path: "/fakerp/produtos",
      children: [
        { index: true, element: <ListProdutoERP /> },
        { path: "criar", element: <CriarProdutoErp /> },
      ],
    },
    {
      path: "/fakerp/pedido",
      element: <PedidoErp />,
    },
    {
      path: "/fakerp/pedido-itens",
      element: <FormAddItemPedido />,
      children: [
        {
          path: ":id",
          element: <FormAddItemPedido />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-carregamento",
      element: <ListCarregamento />,
    },
    {
      path: "fakerp/consulta-de-fornecedores",
      element: <EntradaFornecedor />,
      children: [{ path: ":id" }],
    },
    {
      path: "/fakerp/filial-erp",
      element: <FilialFakeErpComponent />,
    },
    {
      path: "/fakerp/cadastro-de-nota",
      element: (
        <PeriodProvider>
          <NotaERPComponent />
        </PeriodProvider>
      ),
      children: [
        {
          path: "create",
          element: <ModalCadastroDeNotas />,
        },
        {
          path: ":id",
          element: <ModalCadastroDeNotas />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-itens-nota/:id",
      element: (
        <PeriodProvider>
          <NotaItensERPComponentV2 />
        </PeriodProvider>
      ),
      children: [
        {
          path: "create",
          element: <FormItemNota />,
        },
        {
          path: ":iditens",
          element: <FormItemNota />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-itens-nota/:id/create/importProcessor",
      element: (
        <PeriodProvider>
          <ImportNotaItem />
        </PeriodProvider>
      ),
    },

    {
      path: "/fakerp/cadastro-de-grupo",
      element: (
        <>
          <Outlet />
        </>
      ),
      children: [
        {
          path: "",
          element: <GrupoErpComponent />,
        },
      ],
    },
    {
      path: "/fakerp/cadastro-de-subgrupo",
      element: (
        <>
          <Outlet />
        </>
      ),
      children: [
        {
          path: "",
          element: <SubGrupoErp />,
        },
      ],
    },
    {
      path: "fakerp/consulta-de-regioes",
      element: <ExpedicaoRegioes />,
    },
    {
      path: "fakerp/consulta-de-cidades",
      element: <CidadeErp />,
    },
    {
      path: "fakerp/consulta-de-rotas",
      element: <ExpedicaoRotas />,
    },
    {
      path: "fakerp/consulta-de-clientes",
      element: <ExpedicaoClientes />,
      children: [{ path: ":id", element: <DetalhesClientes /> }],
    },
    {
      path: "fakerp/consulta-de-transportadoras",
      element: <ExpedicaoTransportadoras />,
      children: [
        { path: ":id", element: <DetalhesTransportadoras /> }, 
        { path: "editar/:id", element: <EditTransportadora /> }
      ],
    },
    {
      path: "fakerp/consulta-de-veiculos-de-transportadoras",
      element: <ExpedicaoVeiculoTransportadoras />,
      children: [{ path: ":id", element: <DetalhesVeiculoTransportadoras /> }],
    },
    {
      path: "/fakerp/importacao-container",
      element: <Container />,
    },
  ],
};
